import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { ReportService } from "../../../Report/report.service";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_Student_Point } from "../shared/data.service";
import { GroupAddPointComponent } from "./group-add-point/group-add-point.component";
import { GroupPrintPointOptionsComponent } from "./group-print-point-options/group-print-point-options.component";
import { GroupRedeemPointComponent } from "./group-redeem-point/group-redeem-point.component";
import * as moment from "moment";

@Component({
	selector: "caass-student-pbis-group-mode",
	templateUrl: "./student-pbisgroup-mode.component.html",
	styleUrls: ["./student-pbisgroup-mode.component.css"],
})
export class StudentPBISGroupModeComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private PBISService: DataService_Student_Point,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private reportService: ReportService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	School: any;

	GroupLoading: boolean = true;
	Group: any;
	lstGroup: any = [];

	StartDate: Date = new Date();
	EndDate: Date = new Date();
	ShowVoid: boolean = false;

	isProcessing: boolean = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPointsGroupTransaction: any;
	lstPointsGroupTransaction: any = [];

	//Filter lists
	lstIsVoidDesc: any = [];
	lstPointsTransactionTypeDesc: any = [];
	lstPointsItemDesc: any = [];
	lstAddStudentPromptDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "TransactionDTDesc", header: "Date/Time" },
		{ field: "PointsTransactionTypeDesc", header: "Transaction Type" },
		{ field: "PointsItemDesc", header: "Point" },
		{ field: "PointsItemValue", header: "Point Value" },
		{ field: "IsVoidDesc", header: "Voided?" },
		// { field: 'AddStudentPromptDesc', header: 'Auto-Assign' },
		// { field: 'AssignedCountDesc', header: 'Assigned Transaction' },
		// { field: 'UnassignedCountDesc', header: 'Missing Transaction' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadGroups() {
		if (this.School == null) {
			return;
		}

		this.GroupLoading = true;

		var result = this.PBISService.GroupSelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				if (this.lstGroup.length > 0) {
					this.Group = this.lstGroup[0];
				} else {
					this.Group = null;
				}

				this.GroupLoading = false;

				this.loadPointsGroupTransaction();
			},
			(error) => {
				this.GroupLoading = false;
			}
		);
	}

	loadPointsGroupTransaction() {
		if (this.Group == null || this.Group == undefined) {
			return;
		}

		this.loading = true;

		var result = this.PBISService.PBISGroupSelectList(
			this.Group.GroupID,
			moment(this.StartDate).format("MM/DD/YYYY"),
			moment(this.EndDate).format("MM/DD/YYYY"),
			this.ShowVoid == true ? 1 : 0
		);
		result.subscribe(
			(response) => {
				this.lstPointsGroupTransaction = response;

				//Load Data Filter Lists
				this.lstPointsTransactionTypeDesc = Array.from(
					new Set(this.lstPointsGroupTransaction.map((item: any) => item.PointsTransactionTypeDesc))
				).sort();
				this.lstPointsItemDesc = Array.from(new Set(this.lstPointsGroupTransaction.map((item: any) => item.PointsItemDesc))).sort();
				this.lstIsVoidDesc = Array.from(new Set(this.lstPointsGroupTransaction.map((item: any) => item.IsVoidDesc))).sort();
				this.lstAddStudentPromptDesc = Array.from(new Set(this.lstPointsGroupTransaction.map((item: any) => item.AddStudentPromptDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadPointsGroupTransaction();
	}

	//Custom Button Methods
	onAddPoint() {
		this.errorMessage = "";

		var ref = this.dialogService.open(GroupAddPointComponent, {
			header: "Add Point",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.School.SchoolID,
				SchoolName: this.School.SchoolName,
				GroupID: this.Group.GroupID,
				GroupName: this.Group.GroupName,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPointsGroupTransaction();
			}
		});
	}

	onRedeemPoint() {
		this.errorMessage = "";

		var ref = this.dialogService.open(GroupRedeemPointComponent, {
			header: "Redeem Point",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.School.SchoolID,
				SchoolName: this.School.SchoolName,
				GroupID: this.Group.GroupID,
				GroupName: this.Group.GroupName,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPointsGroupTransaction();
			}
		});
	}

	onVoidPoint() {
		this.errorMessage = "";

		if (this.SelectedPointsGroupTransaction == undefined) {
			this.errorMessage = "Select a transaction to void/ignore";
			return;
		}

		if (this.SelectedPointsGroupTransaction.IsVoid == 1) {
			this.errorMessage = "Cannot void/ignore a voided transaction";
			return;
		}

		this.confirmationService.confirm({
			key: "group",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Do you want to void/ignore this transaction?",
			header: "Confirm Void Transaction",
			icon: "fa",
			accept: () => {
				this.FinishVoid();
			},
		});
	}

	FinishVoid() {
		this.isProcessing = true;

		var result = this.PBISService.GroupPointsVoid(this.SelectedPointsGroupTransaction.PointsGroupTransactionID);
		result.subscribe(
			(response: any) => {
				this.isProcessing = false;

				if (response.IsError == false) {
					this.onRowUnselect(null);
					this.loadPointsGroupTransaction();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "group",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not void/ignore the transaction: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							//this.loadStats();
							//this.loadStudentPBISData();

							this.isProcessing = false;
						},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	onPrintPoint() {
		this.errorMessage = "";

		var ref = this.dialogService.open(GroupPrintPointOptionsComponent, {
			header: "Print Point",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.School.SchoolID,

				// user: this.user,
				// SchoolName: this.School.SchoolName,
				// GroupID: this.Group.GroupID,
				// GroupName: this.Group.GroupName
			},
		});
		ref.onClose.subscribe((response: any) => {
			// console.log("Response");
			// console.log(response);

			if (response.OrderByOption != undefined) {
				this.onRowUnselect(null);
				this.FinishPrint(response.OrderByOption, response.ImageLogo, response.OutputTypeID);
			}
		});
	}

	FinishPrint(OrderByOption, ImageLogo, OutputTypeID) {
		this.errorMessage = "";

		var component = this;
		this.errorMessage = "";

		var strParam = "";
		this.isProcessing = true;

		//Insert Custom Parameters Here
		//Parameter 1: SchoolID
		strParam += this.School.SchoolID + "|SchoolID";

		//Parameter 2: GroupID
		strParam += "," + this.Group.GroupID + "|GroupID";

		//Parameter 3: StartDate
		strParam += "," + moment(this.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 4: EndDate
		strParam += "," + moment(this.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 5: ShowVoid
		strParam += "," + (this.ShowVoid == true ? "1" : "0") + "|ShowVoided";

		//Parameter 6: Order By
		strParam += "," + OrderByOption + "|ORDERBY";

		//Parameter 7: Logo
		strParam += "," + ImageLogo + "|ImageLogo";

		var reportID = 443;

		//Add person selector
		var result = this.reportService.Print(reportID, strParam, this.School.SchoolID, OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	onAddMissingPoint() {
		this.errorMessage = "";

		if (this.SelectedPointsGroupTransaction == undefined) {
			this.errorMessage = "Select a transaction to add to all group members";
			return;
		}

		this.confirmationService.confirm({
			key: "group",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Do you want to add this transaction to all of the group members who are missing it?",
			header: "Confirm Add Missing Transaction",
			icon: "fa",
			accept: () => {
				this.FinishAddMissing();
			},
		});
	}

	FinishAddMissing() {
		this.isProcessing = true;

		var result = this.PBISService.GroupPointsAddMissing(this.SelectedPointsGroupTransaction.PointsGroupTransactionID, this.user.personID);
		result.subscribe(
			(response: any) => {
				this.isProcessing = false;

				if (response.IsError == false) {
					this.onRowUnselect(null);
					this.loadPointsGroupTransaction();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "group",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add missing transaction entries: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							//this.loadStats();
							//this.loadStudentPBISData();

							this.isProcessing = false;
						},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	onDeletePoint() {
		this.errorMessage = "";

		if (this.SelectedPointsGroupTransaction == undefined) {
			this.errorMessage = "Select a transaction to delete";
			return;
		}

		this.confirmationService.confirm({
			key: "group",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Do you want to delete this transaction?",
			header: "Confirm Delete Transaction",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
		});
	}

	FinishDelete() {
		this.isProcessing = true;

		var result = this.PBISService.GroupPointsDelete(this.SelectedPointsGroupTransaction.PointsGroupTransactionID);
		result.subscribe(
			(response: any) => {
				this.isProcessing = false;

				if (response.IsError == false) {
					this.onRowUnselect(null);
					this.loadPointsGroupTransaction();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "group",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the transaction: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							//this.loadStats();
							//this.loadStudentPBISData();

							this.isProcessing = false;
						},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	onToggleAutoAssign(PointsGroupTransaction) {
		this.isProcessing = true;

		var result = this.PBISService.GroupPointsUpdateStudentPrompt(
			PointsGroupTransaction.PointsGroupTransactionID,
			PointsGroupTransaction.AddStudentPrompt == true ? 0 : 1
		);
		result.subscribe(
			(response: any) => {
				this.isProcessing = false;

				if (response.IsError == false) {
					this.onRowUnselect(null);
					this.loadPointsGroupTransaction();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "group",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the transaction: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							//this.loadStats();
							//this.loadStudentPBISData();

							this.isProcessing = false;
						},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onSchoolChange(val) {
		this.School = val;

		this.loadGroups();
	}

	onGroupChange(val) {
		this.Group = val;

		this.loadPointsGroupTransaction();
	}

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadPointsGroupTransaction();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadPointsGroupTransaction();
	}

	onVoidChange(val) {
		this.errorMessage = "";

		this.ShowVoid = val;

		this.loadPointsGroupTransaction();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPointsGroupTransaction = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPointsGroupTransaction = null;
	}
	onRowDblClick(PointsGroupTransaction) {
		this.SelectedPointsGroupTransaction = PointsGroupTransaction;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.GroupLoading == true || this.isProcessing == true;
	}

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	////////////////////////////////////////////
}
